import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mr-x1"
}
const _hoisted_2 = { class: "font-inherit whitespace-nowrap" }
const _hoisted_3 = {
  key: 0,
  class: "font-montserrat text-11 ml-x2 line-through xl:text-13"
}
const _hoisted_4 = { class: "sr-only" }
const _hoisted_5 = { class: "whitespace-nowrap" }

import { GlobalLabels } from '@/shared/content/site-context.store';
import useGlobalLabels from '@/shared/content/useGlobalLabels';
import useNetPrices from '@/b2b/product/useNetPrices';
import NetPrice from '@/b2b/shared/auth/ui/NetPrice.vue';
import { computed, ComputedRef, ref, watch } from 'vue';
import { ProductPriceModel } from '@/b2b/shared/api/server-apis';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductNetPrice',
  props: {
    variantId: null,
    isMainPdpPrice: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { variantId: string, isMainPdpPrice: boolean }



const { getNetPrice, getIsNotInAssortment } = useNetPrices();
const globalLabels = useGlobalLabels(GlobalLabels.product);
const textStyling = props.isMainPdpPrice ? 'o-text-h4 font-cormorant mt-x2 px-x2' : 'o-text-caption px-x1';

const internalPrice = ref<ProductPriceModel | undefined>();
const price: ComputedRef<ProductPriceModel | undefined> = computed(() => getNetPrice(props.variantId));

const notInAssortment: ComputedRef<boolean> = computed(() => getIsNotInAssortment(props.variantId));

watch(price, (value) => {
    if (value) {
        internalPrice.value = value;
    }
}, { immediate: true });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (internalPrice.value)
      ? (_openBlock(), _createBlock(NetPrice, { key: "netPrice" }, {
          default: _withCtx(() => [
            _createVNode(_Transition, {
              name: "o-anim-fade-200",
              mode: "out-in"
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", {
                  class: _normalizeClass(["bg-partner-alt inline-flex py-2", _unref(textStyling)])
                }, [
                  (__props.isMainPdpPrice)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_unref(globalLabels).netPrice), 1))
                    : _createCommentVNode("", true),
                  (_openBlock(), _createElementBlock("span", {
                    key: internalPrice.value.salesPrice.rawAmount + internalPrice.value.listPrice.rawAmount,
                    class: "flex justify-end flex-wrap"
                  }, [
                    _createElementVNode("span", _hoisted_2, _toDisplayString(internalPrice.value?.salesPrice.amount), 1),
                    (internalPrice.value?.discount)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                          _createElementVNode("span", _hoisted_4, _toDisplayString(`${_unref(globalLabels).previousListPrice}:`), 1),
                          _createElementVNode("span", _hoisted_5, _toDisplayString(internalPrice.value?.listPrice.amount), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                ], 2)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_Transition, {
      name: "o-anim-fade-200",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_unref(notInAssortment))
          ? (_openBlock(), _createElementBlock("p", {
              key: "notInAssortment",
              class: _normalizeClass(["bg-partner-alt inline-flex py-2", _unref(textStyling)])
            }, _toDisplayString(_unref(globalLabels).notInYourAssortment), 3))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})